import type { InspirationItem } from "@/types";

/**
 * Inspirações Auréa — 8 imagens próprias e distintas.
 * Nenhuma delas é reaproveitada em outra seção do site.
 */
export const inspirations: InspirationItem[] = [
  {
    id: "sandalia-detalhe",
    label: "Detalhe de sandália",
    tall: true,
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20macro%20detail%20of%20bordeaux%20leather%20sandal%20straps%20and%20a%20square%20block%20heel%20on%20a%20light%20cream%20surface%2C%20close%20up%20on%20stitching%20and%20buckle%2C%20soft%20directional%20light%2C%20realistic%20leather%20grain%2C%20elegant%20minimal%20composition%2C%20no%20people%2C%20no%20text%2C%20no%20logos%2C%20no%20watermark&width=700&height=950&seq=aur-insp-sandalia-detalhe&orientation=portrait&nocache=true",
  },
  {
    id: "tenis-urbano",
    label: "Tênis na cidade",
    tall: false,
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20photo%20of%20white%20and%20grey%20leather%20sneakers%20on%20a%20light%20concrete%20urban%20step%2C%20low%20angle%20showing%20both%20shoes%2C%20deep%20bordeaux%20painted%20wall%20detail%20behind%2C%20warm%20neutral%20tones%2C%20natural%20daylight%2C%20realistic%20texture%2C%20no%20people%2C%20no%20text%2C%20no%20logos%2C%20no%20watermark&width=700&height=700&seq=aur-insp-tenis-urbano&orientation=squarish&nocache=true",
  },
  {
    id: "rasteira-pedra",
    label: "Rasteiras na pedra",
    tall: false,
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20detail%20of%20areia%20woven%20flat%20sandals%20resting%20on%20a%20light%20natural%20stone%20slab%20outdoors%2C%20warm%20afternoon%20sunlight%20and%20soft%20shadows%2C%20realistic%20woven%20leather%20texture%2C%20no%20people%2C%20no%20text%2C%20no%20logos%2C%20no%20watermark&width=700&height=700&seq=aur-insp-rasteira-pedra&orientation=squarish&nocache=true",
  },
  {
    id: "salto-noturno",
    label: "Salto à noite",
    tall: true,
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20photo%20of%20cherry%20red%20stiletto%20pumps%20on%20an%20elegant%20dark%20floor%20at%20night%20with%20warm%20reflections%2C%20cinematic%20low%20light%2C%20structurally%20correct%20heels%2C%20realistic%20leather%20texture%2C%20no%20people%2C%20no%20text%2C%20no%20logos%2C%20no%20watermark&width=700&height=950&seq=aur-insp-salto-noturno&orientation=portrait&nocache=true",
  },
  {
    id: "bolsa-estruturada",
    label: "Bolsa estruturada",
    tall: false,
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20still%20life%20of%20a%20structured%20cognac%20leather%20handbag%20with%20a%20metal%20clasp%20on%20a%20warm%20sand%20stucco%20block%2C%20soft%20architectural%20light%2C%20clean%20minimal%20composition%2C%20realistic%20leather%20grain%2C%20no%20people%2C%20no%20text%2C%20no%20logos%2C%20no%20watermark&width=700&height=700&seq=aur-insp-bolsa-estruturada&orientation=squarish&nocache=true",
  },
  {
    id: "cintos-fivelas",
    label: "Cintos e fivelas",
    tall: false,
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20still%20life%20of%20two%20leather%20belts%20with%20visibly%20different%20buckles%2C%20one%20thin%20black%20belt%20and%20one%20wide%20cognac%20belt%20with%20a%20large%20organic%20golden%20buckle%2C%20arranged%20on%20a%20light%20cream%20surface%2C%20soft%20side%20light%2C%20realistic%20leather%20and%20metal%2C%20no%20people%2C%20no%20text%2C%20no%20logos%2C%20no%20watermark&width=700&height=700&seq=aur-insp-cintos-fivelas&orientation=squarish&nocache=true",
  },
  {
    id: "brincos-colar",
    label: "Brincos e colar",
    tall: true,
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20macro%20still%20life%20of%20a%20gold%20plated%20sculptural%20earring%20pair%20and%20a%20thin%20light%20point%20necklace%20arranged%20on%20a%20light%20stone%20surface%20with%20a%20champagne%20accent%2C%20realistic%20metal%20finish%2C%20soft%20light%2C%20no%20people%2C%20no%20text%2C%20no%20logos%2C%20no%20watermark&width=700&height=950&seq=aur-insp-brincos-colar&orientation=portrait&nocache=true",
  },
  {
    id: "composicao-completa",
    label: "Combinação completa",
    tall: false,
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20flat%20lay%20of%20a%20complete%20footwear%20and%20accessories%20combination%20with%20bordeaux%20sandals%2C%20a%20structured%20cognac%20handbag%2C%20a%20woven%20leather%20belt%20and%20gold%20earrings%20arranged%20on%20a%20cream%20surface%20with%20a%20bordeaux%20accent%2C%20soft%20directional%20light%2C%20clean%20minimal%20composition%2C%20no%20text%2C%20no%20logos%2C%20no%20watermark&width=700&height=700&seq=aur-insp-composicao-completa&orientation=squarish&nocache=true",
  },
];